<script>
import UiLoading from '../ui/Loading';
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';

export default {
    mixins: [store],
    components: {
        UiLoading,
    },
    data: () => ({
        error: null,
    }),
    created() {
        const {
            jwt,
            pwgallery,
            pwtoolbox,
        } = this.$route.query;
        if (!jwt) {
            this.error = 'ERROR_UNKNOWN_PARAM';
            return;
        }
        this.logout().then(() => {
            sdk.accessManagement.loginWithJWTToken(jwt, 'mondriaan').then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    sdk.pressengerControl.getCustomMenu().then(modules => {
                        this.setUserInfo(uinfo);
                        this.setCustomMods(modules);
                        if (pwgallery == 1) {
                            this.$router.push({name: 'media', query: {requestedMode: 'pushwize'}});
                        } else if (pwtoolbox == 1) {
                            this.$router.push({name: 'send', query: {requestedMode: 'pushwizeToolbar'}});
                        } else {
                            this.error = 'ERROR_UNKNOWN_PARAM';
                        }
                    }).catch(() => {
                        this.logout();
                        this.error = 'ERROR_AUTH';
                    });
                }).catch(() => {
                    this.logout();
                    this.error = 'ERROR_AUTH';
                });
            }).catch(() => {
                this.logout();
                this.error = 'ERROR_AUTH';
            });
        }).catch(() => {
            this.logout();
            this.error = 'ERROR_AUTH';
        });
    },
};
</script>

<template>
    <p v-if="error === 'ERROR_AUTH'" style="text-align: center">
        <strong>Error:</strong>
        Unable to login.
    </p>
    <p v-else-if="error === 'ERROR_UNKNOWN_PARAM'" style="text-align: center">
        <strong>Error:</strong>
        Unknown params.
    </p>
    <ui-loading v-else />
</template>
